import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { inboxLoginStatus } from '@/state/inboxAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/inbox/routes';

export type AuthenticatedRouteProps = RouteProps;

const AuthenticatedRoute: FC<AuthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(inboxLoginStatus);

  if (loginStatus === 'LOGGED_OUT') {
    return <Redirect to={routes.login.replace(':country?', '')} />;
  }

  return <SentryRoute {...props} />;
};

export default AuthenticatedRoute;
